// src/oauth.js
import { CLIENT_ID, RuName, SCOPES } from './constants.js';
import config from '../../config';

function generateRandomString(length = 16) {
  return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
}

export function initiateEbayOAuth() {
  const state = generateRandomString();
  localStorage.setItem('oauth_state', state);

  const authorizationUrl =
    `${config.ebayAuthorizeUrl}` +
    `?client_id=${CLIENT_ID}&` +
    `redirect_uri=${encodeURIComponent(RuName)}&` +
    `response_type=code&` +
    `scope=${SCOPES}&` +
    `state=${state}`;

  window.location.href = authorizationUrl;
}
